import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import { RequestCekAchievementAssignTaskDto, RequestCekAchievementTaskCompletedDto, RequestDetailAchievementEmployeeDto, RequestaAddMasterBadgeDto, RequestAddMasterPointDto, RequestUpdateMasterPointDto, ResponseGetAchivement, RequestCekAchievementDto, ResponseGetBadgeOnAvatarDto } from '../dto/gamification.dto';
import { ResponseData } from '../../nest-responses';

@Injectable()
export class GamificationNestApi {

  private service: string = 'gamification';
  private model: string = 'gamification';

  constructor(
    public nestApiProvider: NestApiProvider,
  ) {
  }

  public cekAchievementAssignTask(payload: RequestCekAchievementAssignTaskDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'cekAchievement';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public cekAchievement(payload: RequestCekAchievementDto): Observable<ResponseGetAchivement> {
    const method: string = 'POST';
    const func: string = 'cekAchievement';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetAchivement>(method, url, params, urlParams, body);
  }

  public cekAchievementTaskCompleted(payload: RequestCekAchievementTaskCompletedDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'cekAchievement';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public achievementFavorite(payload?: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'achievementFavorite';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public achievement(payload?: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'achievement';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public updateFavorite(payload: { badgeId: number }): Observable<any> {
    const method: string = 'PUT';
    const func: string = 'updateFavorite';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public detailAchievementEmployee(payload: RequestDetailAchievementEmployeeDto): Observable<any> {
    const method: string = 'GET';
    const func: string = 'detailAchievementEmployee';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public achievementInProfile(payload: { empId: string }): Observable<any> {
    const method: string = 'GET';
    const func: string = 'achievementInProfile';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public getOneMasterBadge(payload: { badgeId: number }): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getOneMasterBadge';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public getMasterBadge(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getMasterBadge';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public addMasterBadge(payload: RequestaAddMasterBadgeDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'addMasterBadge';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public updateMasterBadge(payload: { id: number }): Observable<any> {
    const method: string = 'POST';
    const func: string = 'updateMasterBadge';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public deleteMasterBadge(payload: { badgeId: number }): Observable<any> {
    const method: string = 'DELETE';
    const func: string = 'deleteMasterBadge';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public getOneMasterPoint(payload: { pointId: number }): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getOneMasterPoint';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public getMasterPoint(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getMasterPoint';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public addMasterPoint(payload: RequestAddMasterPointDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'addMasterPoint';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public updateMasterPoint(payload: RequestUpdateMasterPointDto): Observable<any> {
    const method: string = 'PUT';
    const func: string = 'updateMasterPoint';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public deleteMasterPoint(payload: { badgeId: number }): Observable<any> {
    const method: string = 'PUT';
    const func: string = 'deleteMasterPoint';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public getDataAchievement(payload: { badgeModule: string }): Observable<ResponseGetAchivement> {
    const method: string = 'GET';
    const func: string = 'getDataAchievement';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetAchivement>(method, url, params, urlParams, body);
  }

  public getAvatar(empId: string): Observable<ResponseData<ResponseGetBadgeOnAvatarDto>> {
    const method: string = 'GET';
    const func: string = 'getAvatar';
    const params: any = {};
    const urlParams: any = { empId: empId };
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseGetBadgeOnAvatarDto>>(method, url, params, urlParams, body, null, null, null, false);
  }

  public setAvatar(badgeId): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'setAvatar';
    const params: any = { badgeId: badgeId };
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/gamification.api.ts